import React from 'react';
import PropTypes from 'prop-types';
import argTypes from 'utils/arg-types';

import AppliedFilters from './AppliedFilters';
import SFAccordion from 'SF/SFAccordion';
import OffscreenAriaLive from 'SF/OffscreenAriaLive';

import { IntakeQuestion, ActiveIntakeFilter } from './intakeTypes';
import intakeFilterDisplayValue from './intakeFilterDisplayValue';
import { MAX_APPLICABLE_INTAKE_FILTERS } from './policy';

import { fromPairs } from 'lodash';

import intakeAppliedFiltersCss from './IntakeAppliedFilters.scss';

const maxFilterDisplayCount = (totalIntakeFilterCount, activeFilterCount) =>
  Math.max(activeFilterCount, Math.min(totalIntakeFilterCount, MAX_APPLICABLE_INTAKE_FILTERS));

const activeIntakeFiltersTitle = (totalIntakeFilterCount, activeFilterCount) => {
  const maxFilters = maxFilterDisplayCount(totalIntakeFilterCount, activeFilterCount);
  return `Applied Filters (${activeFilterCount} of ${maxFilters})`;
};

const objectsByID = (objects, idProperty = 'id') =>
  fromPairs(objects.map(o => [o[idProperty], o]));


const filterLabelsArgTypes =
  argTypes("toFilterLabels",
    PropTypes.arrayOf(IntakeQuestion).isRequired,
    PropTypes.arrayOf(ActiveIntakeFilter).isRequired);

const toFilterLabels = filterLabelsArgTypes((intakeQuestions, activeIntakeFilters) => {
  const filtersByID = objectsByID(activeIntakeFilters, 'questionId');
  return intakeQuestions.filter(question => filtersByID[question.id]).map(question => {
    const filter = filtersByID[question.id];
    return {
      id: question.id,
      label: question.text,
      displayValue: intakeFilterDisplayValue(filter.type, filter.value)
    };
  });
});

const IntakeAppliedFilters = ({intakeQuestions, activeIntakeFilters, onFilterHeightChanged, onClearFilter}) => {
  const intakeFiltersTitle = activeIntakeFiltersTitle(intakeQuestions.length, activeIntakeFilters.length);
  const filters = toFilterLabels(intakeQuestions, activeIntakeFilters);

  return (
    <div>
      <OffscreenAriaLive>
        <h1>{intakeFiltersTitle}</h1>
        <ul>
          {filters.map(filter =>
            <li key={filter.id}>{filter.label} {filter.displayValue}</li>
          )}
        </ul>
      </OffscreenAriaLive>

      {intakeQuestions.length > 0 && (
        <SFAccordion title={intakeFiltersTitle}
                     className={intakeAppliedFiltersCss.intakeFilterAccordion}
                     initiallyExpanded={false}
                     expandable={activeIntakeFilters.length > 0}
                     onExpanded={onFilterHeightChanged}>
          <AppliedFilters filters={filters}
                          onClearFilter={onClearFilter}/>
        </SFAccordion>
      )}
    </div>
  );
};

IntakeAppliedFilters.propTypes = {
  intakeQuestions: PropTypes.arrayOf(IntakeQuestion).isRequired,
  activeIntakeFilters: PropTypes.arrayOf(ActiveIntakeFilter).isRequired,

  onClearFilter: PropTypes.func,
  onFilterHeightChanged: PropTypes.func,
};

export default IntakeAppliedFilters;
